<template>
  <div class="site-menu-component inner" :class="theme">
    <nav>
      <div class="left-links">
        <router-link class="menu-item" to="/about"><label>About</label></router-link>
        <router-link class="menu-item" to="/schedule"><label>Schedule</label></router-link>
        <router-link class="menu-item" to="/checkout"><label>RSVP</label></router-link>
        <router-link class="menu-item" to="/speakers"><label>Speakers</label></router-link>
      </div>
      <div class="right-links">
        <router-link class="menu-item" to="/latest"><label>Latest News</label></router-link>
        <router-link class="menu-item" to="/partners"><label>Partners</label></router-link>
        <router-link class="menu-item" to="/contact"><label>Contact Us</label></router-link>
      </div>
    </nav>
    <router-link to="/">
      <img class="logo colored" src="../assets/logo.svg" />
      <img class="logo white" src="../assets/logo_white.svg" />
    </router-link>
    <mini-divider :height="2" class='divider'/>
  </div>
</template>
<script>
  import MiniDivider from '@/components/MiniDivider.vue'

export default {
    name: 'site-menu-component',
    props: [ 'theme' ],
    components: { MiniDivider },
    data() {
      return {
        openedMenu: null,
      }
    },
    mounted() {
      window.addEventListener('click', this.closeMenuOnClick)
      window.scrollTo(0,0)
    },
    destroyed() {
      window.removeEventListener('click', this.closeMenuOnClick)
    },
    methods: {
      closeMenuOnClick() {
        this.openedMenu = null
      },
      toggleMenu(name) {
        if (this.openedMenu === name) {
          this.openedMenu = null
        } else {
          this.openedMenu = name
        }
      }
    },
  }
</script>
<style scoped lang="scss">
  .site-menu-component {
    position: relative;
    height: 65px;
    z-index: 50;
    &.light {
      .logo.colored {
        display: none;
      }
      .menu-item {
        color: #f0f0f0;
        &:hover, &.selected {
          color: #fff;
        }
      }
      .sub-menu {
        background: #777;
      }
      .sub-menu-item {
        color: #ddd;
        &:hover {
          background: #f0f0f0;
          color: #333;
        }
      }
    }
    &.dark {
      .logo.white {
        display: none;
      }
      .menu-item {
        color: #333;
        &:hover, &.selected {
          color: #000;
        }
      }
      .sub-menu {
        background: #f0f0f0;
      }
      .sub-menu-item {
        color: #777;
        &:hover {
          background: #777;
          color: #fff;
        }
      }
    }
  }
  .left-links {
    position: absolute;
    left: 0;
    top: 30px;
    .menu-item {
      padding: 8px 30px;
    }
  }
  .right-links {
    position: absolute;
    right: 0;
    top: 30px;
  }
  .logo {
    width: 200px;
    margin: 5px auto;
    display: block;
  }
  .menu-item {
    position: relative;
    padding: 8px 35px;
    display: block;
    float: left;
    text-decoration: none;
    font-weight: normal;
    cursor: pointer;
    label {
      cursor: pointer;
      position: relative;
      font-size: 13px;
      text-transform: uppercase;
    }
  }
  .sub-menu {
    position: absolute;
    top: -30px;
    left: 0;
    right: 0;
    padding: 75px 0 10px 0;
  }
  .sub-menu-item {
    position: relative;
    text-decoration: none;
    padding: 5px 5px 5px 20px;
    display: block;
    font-size: 11px;
  }
  .divider {
    margin-top: 10px;
  }
  @media (max-width: 500px) {
    .site-menu-component {
      display: none;
    }
  }
</style>